export default {
  chargeScene: {
    stats: {
      totalCount: 'Total Scenes',
      virtualCount: 'Virtual Scenes',
      physicalCount: 'Physical Scenes',
      disabledCount: 'Disabled',
    },
    loadingTypes: 'Loading scene types...',
    table: {
      title: 'Charge Scene List',
      sceneCode: 'Scene Code',
      sceneName: 'Scene Name',
      chargeRule: 'Charge Rule',
      sceneType: 'Scene Type',
      sceneForm: 'Scene Form',
      shopName: 'Store',
      ruleId: 'Charge Rule',
      pointCount: 'Points',
      bindingDeviceCount: 'Bound Devices',
      status: 'Status',
      createTime: 'Created At',
      action: 'Actions',
    },
    search: {
      keyword: 'Keyword',
      keywordPlaceholder: 'Scene name/code',
      shopName: 'Store',
      sceneForm: 'Scene Form',
      status: 'Status',
    },
    sceneForm: {
      virtual: 'Virtual Scene',
      physical: 'Physical Scene',
    },
    status: {
      enabled: 'Enabled',
      disabled: 'Disabled',
    },
    unit: {
      pointCount: '{count} points',
      deviceCount: '{count} devices',
    },
    action: {
      add: 'Add Charge Scene',
      detail: 'Details',
      binding: 'Bind Devices',
      rule: 'Associate Charge Rule',
      edit: 'Edit',
      enable: 'Enable',
      disable: 'Disable',
      delete: 'Delete',
      refresh: 'Refresh',
    },
    form: {
      addTitle: 'Add Charge Scene',
      editTitle: 'Edit Charge Scene',
      sceneName: 'Scene Name',
      sceneNamePlaceholder: 'Enter scene name',
      sceneCode: 'Scene Code',
      sceneCodePlaceholder: 'Generated after saving',
      sceneType: 'Scene Type',
      sceneTypePlaceholder: 'Select scene type',
      pointCount: 'Points',
      pointCountHint: 'P01, P02... are generated after saving; points with bindings or charge records cannot be deleted directly.',
      sceneForm: 'Scene Form',
      sceneFormHint: 'Determined automatically by scene type and cannot be selected separately.',
      status: 'Status',
      statusPlaceholder: 'Select status',
      shopName: 'Store',
      shopPlaceholder: 'Select store',
      shopRequired: 'Select store',
      remark: 'Remark',
      remarkPlaceholder: 'Enter remark',
      cancel: 'Cancel',
      saveEdit: 'Save Changes',
      saveAdd: 'Save Scene',
      sceneNameRequired: 'Enter scene name',
      sceneTypeRequired: 'Select scene type',
      pointCountRequired: 'Enter point count',
      pointCountRange: 'Point count must be between 1 and 99',
      statusRequired: 'Select status',
      unsavedTitle: 'Unsaved Changes',
      unsavedMessage: 'The current changes are not saved. Close anyway?',
    },
    ruleScenes: {
      tab: 'Charge Scenes',
      configured: 'Configured {count} scenes',
      title: '{name} | Rule Configuration Details',
      empty: 'No associated charge scenes available to view',
      loadFailed: 'Failed to load associated charge scenes. Please try again.',
      retry: 'Retry',
      count: 'Currently visible scenes: {count}',
    },
    rule: {
      addTitle: 'Add Charge Rule',
      editTitle: 'Edit Charge Rule',
      ruleSource: 'Rule Source',
      ruleNoPlaceholder: 'Enter rule number',
      saveRule: 'Save Rule',
      ruleNoInvalid: 'Rule number must contain 1–64 letters or digits only',
      ruleNameTooLong: 'Rule name cannot exceed 64 characters',
      editOwnStoreOnly: 'Stores can only edit charge rules created by their own store',
      deleteConfirm: 'Are you sure you want to delete rule "{name}"?',
      title: 'Associate Charge Rule',
      close: 'Close',
      keyword: 'Keyword',
      keywordPlaceholder: 'Rule name / rule no.',
      sceneName: 'Scene Name',
      shopName: 'Store',
      current: 'Current Rule',
      ruleNo: 'Rule No.',
      ruleName: 'Rule Name',
      ruleNamePlaceholder: 'Enter rule name',
      chargeAssets: 'Charge Assets',
      shopScope: 'Applicable Stores',
      status: 'Enable Status',
      search: 'Search',
      select: 'Select Rule',
      clear: 'Unlink Rule',
      clearTitle: 'Confirm Unlink',
      clearConfirm:
        'Are you sure you want to unlink the current charge rule?',
      unlinked: 'Not Associated',
      unlinkedHint:
        'All points in this scene cannot charge until a rule is saved',
      unlinkedStatus: 'Unlinked',
      allShops: 'All Stores',
      empty: 'No charge rules available',
      loadFailed: 'Failed to load charge rules. Please try again.',
      invalidSceneId: 'The charge scene is invalid, so the rule association cannot be saved.',
      cancel: 'Cancel',
      save: 'Save',
      saved: 'Charge rule association saved',
    },
    detail: {
      title: 'Charge Scene Details',
      sceneCode: 'Scene Code',
      sceneName: 'Scene Name',
      sceneType: 'Scene Type',
      sceneForm: 'Scene Form',
      shopName: 'Store',
      ruleName: 'Charge Rule',
      pointCount: 'Points',
      bindingDeviceCount: 'Bound Devices',
      createTime: 'Created At',
      remark: 'Remark',
      status: 'Status',
      close: 'Close',
    },
    point: {
      title: '{name} | Point Details',
      count: 'Points: {count}',
      adjustCount: 'Adjust Point Count',
      pointName: 'Point Name',
      pointCode: 'Point Code',
      bindingDeviceCount: 'Bound Devices',
      boundDeviceCount: '{count} bound',
      ruleName: 'Effective Charge Rule',
      status: 'Status',
      action: 'Actions',
      binding: 'Bind Devices',
      close: 'Close',
      adjustTitle: 'Adjust Point Count',
      cancel: 'Cancel',
      save: 'Save',
      countUpdated: 'Point count updated',
      enableTitle: 'Confirm Enable Charge Point',
      enableMessage: 'Enabling restores availability of "{sceneName} / {pointName}". Charges still require an enabled scene and an associated charge rule. Other points in the same scene are not affected.',
      disableTitle: 'Confirm Disable Charge Point',
      disableMessage: 'After disabling, "{sceneName} / {pointName}" cannot initiate further charges. Other points in the same scene are not affected.',
      statusUpdated: 'Point status updated',
    },
    binding: {
      title: '{sceneName} / {pointCode} | Bind Devices',
      summary: '{sceneName} / {pointCode}, {count} devices available',
      readShop: 'Device store:',
      shopScopeHint: 'Only cashiers, card readers, and charge piles from this store are shown',
      availableTitle: 'Available Devices',
      description: 'Configuring {sceneName} / {pointCode}; card readers can only bind to one point, and card readers already bound to another scene or point in this store cannot be selected; cashiers and charge piles support multiple selections.',
      deviceCodePlaceholder: 'Device code: Enter',
      deviceNamePlaceholder: 'Device name: Enter',
      reset: 'Reset',
      search: 'Search',
      allDevices: 'All Devices',
      cashier: 'Cashiers',
      card: 'Card Readers',
      chargePile: 'Charge Piles',
      deviceSummary: '{total} devices total, {available} selectable',
      selectedSummary: '{count} selected for current point',
      boundTo: 'Bound to: {name}',
      empty: 'No matching devices',
      keywordPlaceholder: 'Device code/name',
      typePlaceholder: 'Device type',
      allTypes: 'All Types',
      deviceCode: 'Device Code',
      deviceName: 'Device Name',
      deviceType: 'Device Type',
      bindingStatus: 'Binding Status',
      currentPoint: 'Current Point',
      otherPoint: 'Other Point',
      unbound: 'Unbound',
      deviceStatus: 'Device Status',
      close: 'Cancel',
      save: 'Save',
      saved: 'Device bindings saved',
    },
    bindingDetail: {
      title: 'Bound Device Details',
      summary: '{count} devices bound',
      batchUnbind: 'Unbind Selected',
      pointCode: 'Point',
      deviceCode: 'Device Code',
      deviceName: 'Device Name',
      deviceType: 'Device Type',
      unbind: 'Unbind',
      close: 'Close',
      missingPoint: 'The device point was not found',
      unbindConfirm: 'Remove the binding between "{deviceName}" and "{sceneName} / {pointName}"? After unbinding, this point can no longer initiate charges through this device.',
      unbindTitle: 'Confirm Unbind Device',
      batchConfirm: 'Remove the {count} selected device bindings? After unbinding, the affected points can no longer initiate charges through these devices. Unselected bindings are not affected.',
      batchTitle: 'Confirm Batch Unbind Devices',
      unbindSuccess: 'Device unbound',
      batchSuccess: 'Selected devices unbound',
      batchResult: '{success} bindings unbound, {failed} failed',
    },
    confirm: {
      enableTitle: 'Confirm Enable Charge Scene',
      enableMessage: 'Enabling restores availability of enabled points under "{sceneName}". Charges still cannot be initiated without an associated charge rule. The scene cannot be edited or deleted while enabled.',
      disableTitle: 'Confirm Disable Charge Scene',
      disableMessage: 'After disabling, "{sceneName}" and all its points cannot initiate further charges. Existing charge records are not affected. The disabled scene can be edited or deleted.',
      deleteTitle: 'Confirm Delete Charge Scene',
      deleteMessage: 'Deleting removes "{sceneName}" and its points from the charge scene list, along with all device bindings and charge rule associations. Historical charge records are retained for tracing. This action cannot be undone.',
    },
    message: {
      added: 'Added successfully',
      edited: 'Updated successfully',
      deleted: 'Deleted successfully',
      statusEnabled: 'Enabled successfully',
      statusDisabled: 'Disabled successfully',
      ruleApiUnavailable: 'The backend does not provide the charge rule association API yet',
    },
    notLinked: 'Unlinked',
  },
};
